import { useEffect, useState } from 'react';
import lightImg from 'assets/img/spot-illustrations/1.png';
import darkImg from 'assets/img/spot-illustrations/dark_1.png';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { logout } from 'store/authSlice';

const SignOutForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  const dispatch = useDispatch();
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Check what's in sessionStorage before logout
        const userBefore = sessionStorage.getItem('user');
        const accessTokenBefore = sessionStorage.getItem('access_token');
        const refreshTokenBefore = sessionStorage.getItem('refresh_token');

        // Dispatch logout action (this will call the API and clear storage)

        dispatch(logout());

        // Trigger animation after logout
        setTimeout(() => setShowAnimation(true), 100);

        // Check what's in sessionStorage after logout
        setTimeout(() => {
          const userAfter = sessionStorage.getItem('user');
          const accessTokenAfter = sessionStorage.getItem('access_token');
          const refreshTokenAfter = sessionStorage.getItem('refresh_token');
        }, 100);
      } catch (error) {
        console.error('❌ SignOutForm: Logout error:', error);
      }
    };

    performLogout();
  }, [dispatch]);

  return (
    <div className="text-center mb-6 mx-auto">
      <div
        className={`logout-success-animation mb-4 ${
          showAnimation ? 'show' : ''
        }`}
      >
        <div className="success-checkmark">
          <FontAwesomeIcon icon={faCircleCheck} />
        </div>
      </div>
      <div className="mb-6">
        <h4 className="text-body-highlight">Come back soon!</h4>
        <p className="text-body-tertiary">
          Thanks for Choosing Blue Sky. <br className="d-lg-none" />
          You are now successfully signed out.
        </p>
      </div>
      <div className="d-grid">
        <Button
          variant="primary"
          as={Link}
          // to={`/sign-in`}
          to={`/login`}
          startIcon={<FontAwesomeIcon icon={faAngleLeft} className="me-2" />}
        >
          Go to sign in page
        </Button>
      </div>
    </div>
  );
};

export default SignOutForm;
